import React, { useState } from "react";
import { Button, Form, Input } from "antd";
import {
  CloseOutlined,
  LockOutlined,
  MailOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import fire from "../../fire";
import image from "../../assets/images/sign-up.svg";
import {
  Container,
  InfoSection,
  InfoSectionImg,
  Title,
  TitleHead,
  TitleInfo,
  ActivitySection,
  ActvtySecWrapper,
  ActvtySecTitle,
  AlertMessageContainer,
  AlertMessage,
  AlertMessageContent,
  IconContainer,
  InfoSectionFig,
} from "../../Styles";
import "../../Styles.css";

const Signup = () => {
  const history = useHistory();
  const [errorMessage, seterrorMessage] = useState("");

  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 8,
      },
    },
    wrapperCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 16,
      },
    },
  };

  const onFinish = (values: any) => {
    // console.log("Received values of form: ", values);
    fire
      .auth()
      .createUserWithEmailAndPassword(values.email, values.password)
      .then((userCredential) => {
        // Signed in
        // var user = userCredential.user;
        // ...
        history.push("/");
      })
      .catch((error) => {
        // var errorCode = error.code;
        // var errorMessage = error.message;
        // console.log(errorMessage);
        seterrorMessage(error.message);
      });
  };

  return (
    <Container>
      <InfoSection>
        <InfoSectionFig>
          {" "}
          <InfoSectionImg src={image} />
        </InfoSectionFig>
        <Title>
          <TitleHead className="FontMontserrat">Some title goes here</TitleHead>
          <TitleInfo>
            Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
            sint. Velit officia consequat duis enim velit mollit. Exercitation
            veniam consequat sunt nostrud amet.
          </TitleInfo>
        </Title>
      </InfoSection>
      <ActivitySection>
        <ActvtySecWrapper className="signupForm">
          <ActvtySecTitle>Sign Up</ActvtySecTitle>
          {errorMessage && (
            <AlertMessageContainer style={{ top: "-44%" }}>
              <AlertMessage style={{ height: "14px" }}>
                <AlertMessageContent>{errorMessage}</AlertMessageContent>
                <IconContainer>
                  <CloseOutlined onClick={() => seterrorMessage("")} />
                </IconContainer>
              </AlertMessage>
            </AlertMessageContainer>
          )}
          <Form
            className="signupFom"
            {...formItemLayout}
            name="register"
            onFinish={onFinish}
            initialValues={{}}
            scrollToFirstError
            // style={{ width: "140%" }}
          >
            <Form.Item
              name="email"
              rules={[
                {
                  type: "email",
                  message: "This is not valid E-mail!",
                },
                {
                  required: true,
                  message: "Please Enter Your Email ID!",
                },
                {
                  pattern: /[@]/g,
                  message: "An Email Address Must Contain a Single @!",
                },
              ]}
            >
              <Input
                style={{ fontFamily: "Montserrat" }}
                prefix={<MailOutlined className="site-form-item-icon" />}
                placeholder="user@gmail.com"
              />
            </Form.Item>
            <Form.Item
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please Enter Your Name!",
                  whitespace: true,
                },
              ]}
            >
              <Input
                style={{ fontFamily: "Montserrat" }}
                placeholder="Name"
                prefix={<UserOutlined className="site-form-item-icon" />}
              />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please Enter Your Password!",
                },
                {
                  pattern:
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/g,
                  message: "Password must contain atleast 8 characters",
                },
                {
                  pattern: /[0-9]{1,}/g,
                  message: "Password must contain atleast 1 number",
                },
                {
                  pattern: /[A-Z]{1,}/g,
                  message:
                    "Password must contain atleast 1 letter in capital case",
                },
                {
                  pattern: /[a-z]{1,}/g,
                  message:
                    "Password must contain atleast 1 letter in small case",
                },
                {
                  pattern: /[^A-Z0-9a-z]{1,}/g,
                  message: "Must contain atleast 1 special character",
                },
              ]}
              hasFeedback
            >
              <Input.Password
                style={{ fontFamily: "Montserrat" }}
                prefix={<LockOutlined className="site-form-item-icon" />}
                placeholder="Password"
              />
            </Form.Item>

            <Form.Item
              name="confirm"
              dependencies={["password"]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Please Confirm Your Password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }

                    return Promise.reject(
                      new Error(
                        "The two passwords that you entered do not match!"
                      )
                    );
                  },
                }),
              ]}
            >
              <Input.Password
                style={{ fontFamily: "Montserrat" }}
                prefix={<LockOutlined className="site-form-item-icon" />}
                placeholder="Comfirm Password"
              />
            </Form.Item>
            <Form.Item>
              <Button className="loginButton" type="primary" htmlType="submit">
                Sign Up
              </Button>
            </Form.Item>
            <p>
              {" "}
              Already have an Account ?{" "}
              <a
                onClick={() => {
                  history.push("/");
                }}
              >
                Login Now
              </a>
            </p>
          </Form>
        </ActvtySecWrapper>
      </ActivitySection>
    </Container>
  );
};

export default Signup;
